/**
 * Determines the appropriate response type button text based on selected tickets
 * @param {Array} selectedTickets - Array of selected ticket IDs
 * @param {Array} allDocs - Array of all documents
 * @param {Object} ticketDetail - Current ticket detail object
 * @returns {string|null} - Response type text or null if invalid
 */
export const getResponseTypeFromTickets = (
  selectedTickets,
  allDocs,
  ticketDetail
) => {
  if (!selectedTickets || selectedTickets.length === 0) {
    return null;
  }

  // If only one ticket is selected, check the ticket detail
  if (selectedTickets.length === 1) {
    const ticket = ticketDetail || allDocs?.find(doc => doc.id === selectedTickets[0]);
    
    if (!ticket) {
      return null;
    }

    const doc = ticket.doc || ticket;
    
    if (doc.pge_status === 'OPEN' || doc.pge_status === 'ONGOING') {
      let responseType = doc.docType;
      
      if (responseType === 'fieldMeet') {
        responseType = doc.fieldMeetScheduledDate ? 'scheduledFieldMeet' : 'unscheduledFieldMeet';
      } else if (responseType === 'standby') {
        responseType = doc.standbyScheduledDate ? 'scheduledStandby' : 'unscheduledStandby';
      }
      
      switch (responseType) {
        case 'scheduledFieldMeet':
          return 'Update';
        case 'unscheduledFieldMeet':
        case 'unscheduledStandby':
          return 'Complete';
        case 'scheduledStandby':
          return 'Complete';
        case 'ticket':
          return 'Respond';
        default:
          return 'Respond';
      }
    }
    
    return null;
  }

  // For multiple tickets, check if they all have the same response type
  const tickets = selectedTickets
    .map(id => allDocs?.find(doc => doc.id === id))
    .filter(Boolean);

  if (tickets.length === 0) {
    return null;
  }

  // Check if all selected tickets are open/ongoing
  const allOpen = tickets.every(
    ticket => 
      ticket.doc?.pge_status === 'OPEN' || 
      ticket.doc?.pge_status === 'ONGOING'
  );

  if (!allOpen) {
    return null;
  }

  // Return generic respond for multiple tickets
  return 'Respond';
};
